module.exports = __webpack_public_path__ + "static/media/rating.8d1e1231.jpg";